import React, { useState, useCallback } from 'react';

import { WpPopover, WpPopoverToggle, WpPopoverContent } from 'Wpds/components/popover';
import WpGifPicker, { WpGifPickerProps } from './WpGifPicker';
import { PopoverOptions } from 'Wpds/components/popover/types';

interface Props extends WpGifPickerProps, PopoverOptions {
  children: React.ReactNode;
}

const WpGifPickerDropdown = ({
  children,
  onSelect,
  autoFocus,
  initialSearchTerm,
  open,
  onOpenChange,
  initialOpen,
  showArrow = false,
  ...rest
}: Props) => {
  const [isOpen, setIsOpen] = useState(initialOpen || open);

  const handleOpenChange = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const handleOnSelect = gif => {
    onSelect && onSelect(gif);
    setIsOpen(false);
  };

  return (
    <WpPopover
      open={isOpen}
      onOpenChange={handleOpenChange}
      showArrow={showArrow}
      withStyling={false}
      withPadding={false}
      withBoxShadow
      {...rest}
    >
      <WpPopoverToggle>{children}</WpPopoverToggle>
      <WpPopoverContent>
        <WpGifPicker onSelect={handleOnSelect} initialSearchTerm={initialSearchTerm} autoFocus={autoFocus} />
      </WpPopoverContent>
    </WpPopover>
  );
};

export default WpGifPickerDropdown;
